import React, {
  useCallback, useContext, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import {
  AssetDistributionOption, ButtonBar, ScreenHeader
} from '../../components';
import { useScrollToTop } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';

export function NewPOAEstateTrust() {
  const { powerOfAttorney, setPowerOfAttorney } = useContext(NewPOAContext);
  const navigate = useNavigate();
  const [ estateTrust, setEstateTrust ] = useState(powerOfAttorney.estate_trust_transactions || false);
  
  useScrollToTop();
  
  const handleBack = useCallback(() => {
    navigate('../business-operations');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    setPowerOfAttorney(prev => ({ 
      ...prev, 
      estate_trust_transactions: estateTrust
    }));
    navigate('../living-trust');
  }, [ estateTrust, setPowerOfAttorney, navigate ]);
  
  return (
    <div className="new-poa-estate-trust screen-container screen">
      <ScreenHeader
        title="Estate & Trust Transactions"
        description="Decide whether to grant your agent power over estate and trust matters"
        handleBack={handleBack}
      />
      
      <div className="content-section">
        <h3>What Are Estate & Trust Powers?</h3>
        <p>
          Estate and trust powers allow your agent to handle matters related to estates, 
          trusts, and inheritance planning. This includes:
        </p>
        <ul className="estate-trust-list">
          <li>Managing trust assets and distributions</li>
          <li>Acting as trustee or successor trustee</li>
          <li>Making trust-related decisions</li>
          <li>Handling estate administration</li>
          <li>Managing inheritance matters</li>
          <li>Filing estate and trust tax returns</li>
          <li>Distributing trust income and principal</li>
        </ul>

        <h3>What Your Agent Can Do</h3>
        <p>If you grant this power, your agent can:</p>
        <ul className="agent-powers">
          <li>Administer trusts on your behalf</li>
          <li>Make distributions to beneficiaries</li>
          <li>Manage trust investments and assets</li>
          <li>File necessary tax returns and documents</li>
          <li>Handle estate planning transactions</li>
          <li>Work with attorneys and financial advisors</li>
        </ul>

        <h3>Do You Want to Grant This Power?</h3>
        <div className="asset-distribution-option-container">
          <AssetDistributionOption
            id="estate-trust-yes"
            label="Yes"
            description="Grant power over estate and trust transactions"
            value="yes"
          />
          <AssetDistributionOption
            id="estate-trust-no"
            label="No"
            description="Do not grant power over estate and trust transactions"
            value="no"
          />
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}
